import React, { useContext, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  DBT_MINOR_ERROR_TYPE,
  REGISTRATION_EVENTS,
  REGISTRATION_PROPERTIES,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'

import { AppContext } from '../../../context'
import { InlineErrorBanner } from '../../../molecules/inlineErrorBanner/InlineErrorBanner'
import { UICoreFieldProps } from '../../../organisms/formBody/types'

/**
 * Error banner displayed when a DBT user selects "No, for a teen" option.
 * This is a blocking error - users cannot proceed with registration when seeking care for a teen.
 */
export const DbtTeenErrorBanner: React.FC<UICoreFieldProps> = (props) => {
  const { trackEvent } = useContext(AppContext)
  const hidden = props.schema?.hidden

  const hasFiredRef = useRef(false)

  // Only fire event once when banner is displayed
  useEffect(() => {
    if (!hidden && !hasFiredRef.current) {
      hasFiredRef.current = true
      trackEvent?.(REGISTRATION_EVENTS.VIEW_DBT_MINOR_ERROR_BANNER, {
        [REGISTRATION_PROPERTIES.DBT_MINOR_ERROR]: DBT_MINOR_ERROR_TYPE.DEPENDENT_MINOR,
      })
    } else if (hidden) {
      hasFiredRef.current = false
    }
  }, [hidden, trackEvent])

  return (
    <InlineErrorBanner
      text={
        <FormattedMessage
          defaultMessage='This service is currently unavailable for teens. For additional support, contact care@lyrahealth.com'
          description='Error state if user chooses “No, I’m searching for a teen dependent”'
        />
      }
      testId='DbtTeenErrorBanner'
    />
  )
}
